$(".media-library__asset-img, .media-library__asset-vid").click(function(){
    $('.media-library__asset-dl-bg').removeClass('hidden');
    $(this).children('.media-library__asset-dl').removeClass('hidden');
}).children().children().not('img, a').click(function(e) {
    return false;
});

$('.media-library__asset-dl-bg, .media-library__asset-dl-close').on("click", function() {
    $('.media-library__asset-dl-bg, .media-library__asset-dl').addClass('hidden');
});

var mediaOptions = $(".media-library__options > .images, .media-library__options > .videos, .media-library__options > .documents");
$(mediaOptions).click(function(){
    // if($(this).hasClass('clicked-pill')) {
    //     $('.media-library__asset-vid, .media-library__asset-img, .media-library__asset-doc').removeClass('hidden');
    //     $(this).removeClass('clicked-pill');
    // }
    // else {
        $(mediaOptions).removeClass('clicked-pill');
        $(this).addClass('clicked-pill');
        $('.media-library__asset-vid, .media-library__asset-doc, .media-library__asset-img').addClass('hidden');
        if($(this).hasClass('images')) {
            $('.media-library__asset-img').removeClass('hidden');
            $('.media-library__asset-filters-category').removeClass('hidden');
            
        }
        else if($(this).hasClass('videos')) {
            $('.media-library__asset-vid').removeClass('hidden');
            $('.media-library__asset-filters-category').addClass('hidden');
        }
        else if($(this).hasClass('documents')) {
            $('.media-library__asset-doc').removeClass('hidden');
            $('.media-library__asset-filters-category').addClass('hidden');
        }
    // }
});


$('.media-library__asset-filters-container input:checkbox').change(function(){
var checkedCategories = [];
$('.media-library__asset-container').fadeOut('fast');
$('.media-library__asset-img').show();
$.each($('.media-library__asset-filters-category input[type="checkbox"]:checked'), function(){
    checkedCategories.push($(this).data('person-category'));
})
if(checkedCategories.length){
    filterPeople(checkedCategories);
}
else{
    $('.media-library__asset-img').show();
    $('.media-library__asset-container').fadeIn('fast');
}

if($(this).is(":checked")) {
    $(this).parent().addClass("checked__status");
} else {
    $(this).parent().removeClass("checked__status");
}
});

var filterPeople = function(categories){
    var showCategories = categories;
        $.each($('.media-library__asset-img'), function(){
            var obj = this;
            var assetCategories = $(this).data('person-category').split(';');
            $.each(assetCategories, function(key, value){
                var index = $.inArray(value.trim(), showCategories);
                    if(index == -1){
                        $(obj).hide();
                    }
                    else{
                        $(obj).show();
                        return false;
                    }
                })
            })
    $('.media-library__asset-container').fadeIn('fast');
}

// var maxheightImg = 0;
// var maxheightVid = 0;
// var maxheightDoc = 0;

// $('.media-library__asset-img').each(function () {
//     maxheightImg = ($(this).height() > maxheightImg ? $(this).height() : maxheightImg); 
// });
// $('.media-library__asset-vid').each(function () {
//     maxheightVid = ($(this).height() > maxheightVid ? $(this).height() : maxheightVid); 
// });

// $('.media-library__asset-doc > li').each(function () {
//     maxheightVid = ($(this).height() > maxheightVid ? $(this).height() : maxheightVid); 
// });

// $('.media-library__asset-img').height(maxheightImg);
// $('.media-library__asset-vid').height(maxheightVid);